import { Field, formValueSelector, reduxForm } from 'redux-form';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import { UpdateBatchRateForServiceCodes } from './actions/ManageClaimActions';
import { isValidNameWithSpace, normalizeDecimal, renderAutoCompleteSingleSelect, renderTextField } from '../../../../components/reduxFields';
import { CommonButton } from '../../../../components/buttons';
import SmallLoader from '../../../../img/small-loader.gif';

const validate = (values) => {
  const errors = {};
  if (!values.serviceCode) {
    errors.serviceCode = 'Please enter service code';
  }
  if (!values.rate) {
    errors.rate = 'Please enter rate per unit';
  }
  return errors;
};

class BatchUpdateRateModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,      
    };
    this.onSubmitHandler = this.onSubmitHandler.bind(this);
  }

  componentWillReceiveProps(nextProps) {

    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  }

  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  onSubmitHandler(formData) {
    let postData = {
      claimIds: this.props.selectedEDIAndNonEDIClaimIds,   
      serviceCode: formData.serviceCode,
      modifier1: formData.modifier1,
      modifier2: formData.modifier2,
      modifier3: formData.modifier3,
      modifier4: formData.modifier4,
      rate: formData.rate,
    };
    // console.log(JSON.stringify(postData));
    this.props.UpdateBatchRateForServiceCodes(postData.claimIds, postData.serviceCode, postData.modifier1, postData.modifier2, postData.modifier3, postData.modifier4, postData.rate);
    this.handleClose();
  }

  renderLoading() {
    return (
      <div>
        {this.props.loading ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null}
      </div>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    const actions = [
      <CommonButton label="Cancel" className="mr-15 grey_btn" onTouchTap={() => this.handleClose()} />,
      <CommonButton type="submit" primary={true} label="Update" onTouchTap={handleSubmit(this.onSubmitHandler)} />,
    ];
    return (
      <Dialog className="custom_modal"
        title={'Batch Update Rate'}
        modal={false}
        open={this.state.open}
        actions={actions}
        autoScrollBodyContent={true}>
        <div className="row">
          <div className="col-sm-12">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
              <div className="row">                
                <div className="col-sm-12 col-md-6 require">
                  <Field                    
                    autoFocus={true}
                    name="serviceCode"
                    type="text"
                    maxLength='10'
                    label="Service Code"
                    normalize={isValidNameWithSpace}                   
                    component={renderTextField}
                  />
                </div>
                <div className="col-sm-12 col-md-6 require">
                  <Field
                    // disabled={true}
                    name="rate"
                    type="text"
                    maxLength='8'
                    // value={this.state.RatePerUnit}
                    label="Rate Per Unit ($)"
                    component={renderTextField}
                    normalize={normalizeDecimal}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-6">
                  <Field
                    name="modifier1"
                    label="Modifier 1"
                    type="text"
                    maxLength="20"                    
                    component={renderTextField}
                  />
                </div>
                <div className="col-sm-12 col-md-6">
                  <Field
                    name="modifier2"
                    label="Modifier 2"
                    type="text"
                    maxLength="20"                    
                    component={renderTextField}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-6">
                  <Field
                    name="modifier3"
                    label="Modifier 3"
                    type="text"
                    maxLength="20"                    
                    component={renderTextField}
                  />
                </div>
                <div className="col-sm-12 col-md-6">
                  <Field
                    name="modifier4"
                    label="Modifier 4"
                    type="text"
                    maxLength="20"                    
                    component={renderTextField}
                  />
                </div>
              </div>
              
            </form>
          </div>
        </div>
      </Dialog>
    );
  };
}

BatchUpdateRateModal = reduxForm({
  form: 'BatchUpdateRateModal',
  validate,
  enableReinitialize: true,
})(BatchUpdateRateModal);

const selector = formValueSelector('BatchUpdateRateModal');
function mapStateToProps(state) {
  return {
    loading: state.billing.loading,
  };
}

export default connect(mapStateToProps, { UpdateBatchRateForServiceCodes })(BatchUpdateRateModal);



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/BatchUpdateRate_Modal.js